import './App.scss';

import { CssBaseline, ThemeProvider } from '@mui/material';
import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { RouteScrollHandler, SeoHelmet } from './components';
import { Layout } from './components/Layout';
import { PrivacyGuidelines, TermsOfUse } from './components/staticPages';
import { privacyPolicyPaths, routes, termsOfUsePaths } from './constants';
import { HomePage } from './pages';
import { darkTheme } from './themes/dark.theme';
import { lightTheme } from './themes/light.theme';

function AppContent() {
  const [theme] = useState('dark');
  const currentTheme = theme === 'light' ? lightTheme : darkTheme;

  // const toggleTheme = useCallback(() => {
  //   setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  // }, []);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <RouteScrollHandler />

      <Layout>
        <Routes>
          <Route index element={<HomePage />} />
          <Route path={routes.aboutUs} element={<h1>About us</h1>} />
          <Route path={routes.faq} element={<h1>FAQ</h1>} />

          {/* TODO: This will be needed in the future */}
          {/* <Route
            path={routes.huddVsTheOthers}
            element={<HuddVsTheOthersPage />}
          /> */}

          {privacyPolicyPaths.map((path) => (
            <Route key={path} path={path} element={<PrivacyGuidelines />} />
          ))}
          {termsOfUsePaths.map((path) => (
            <Route key={path} path={path} element={<TermsOfUse />} />
          ))}
        </Routes>
      </Layout>
    </ThemeProvider>
  );
}

function App() {
  return (
    <>
      <SeoHelmet />
      <Router>
        <AppContent />
      </Router>
    </>
  );
}

export default App;
